module.exports = __webpack_public_path__ + "images/eyeMed_3f3f1c6.jpg";